import * as React from 'react';
const Share2 = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-share-2", ...props },
    React.createElement("circle", { cx: "18", cy: "5", r: "3" }),
    React.createElement("circle", { cx: "6", cy: "12", r: "3" }),
    React.createElement("circle", { cx: "18", cy: "19", r: "3" }),
    React.createElement("line", { x1: "8.59", y1: "13.51", x2: "15.42", y2: "17.49" }),
    React.createElement("line", { x1: "15.41", y1: "6.51", x2: "8.59", y2: "10.49" })));
export default Share2;
//# sourceMappingURL=Share2.js.map